// Sugalarm — /api/members/{id}/link_invite + /api/me/link_invites/accept
// + /api/members/{id}/link/{user_id} (cycle 60).

import { request } from "../lib/apiClient";
import type {
  ApiResult,
  MemberLinkGrantListResponse,
  MemberLinkInvite,
  MemberLinkInviteAcceptResponse,
  MemberLinkInviteCreateIn,
  MemberLinkInviteListResponse,
  MemberLinkInviteWithCode,
  MemberLinkUnlinkResponse,
} from "../lib/types";

export function createInvite(
  memberId: string,
  body: MemberLinkInviteCreateIn,
): Promise<ApiResult<MemberLinkInviteWithCode>> {
  return request<MemberLinkInviteWithCode>(
    `/api/members/${memberId}/link_invite`,
    { method: "POST", body },
  );
}

export function listInvites(
  memberId: string,
): Promise<ApiResult<MemberLinkInviteListResponse>> {
  return request<MemberLinkInviteListResponse>(
    `/api/members/${memberId}/link_invites`,
  );
}

export function listGrants(
  memberId: string,
): Promise<ApiResult<MemberLinkGrantListResponse>> {
  return request<MemberLinkGrantListResponse>(
    `/api/members/${memberId}/links`,
  );
}

export function revokeInvite(inviteId: string): Promise<ApiResult<void>> {
  return request<void>(`/api/members/link_invites/${inviteId}`, {
    method: "DELETE",
  });
}

export function unlink(
  memberId: string,
  userId: string,
): Promise<ApiResult<MemberLinkUnlinkResponse>> {
  return request<MemberLinkUnlinkResponse>(
    `/api/members/${memberId}/link/${userId}`,
    { method: "DELETE" },
  );
}

export function acceptInvite(
  code: string,
): Promise<ApiResult<MemberLinkInviteAcceptResponse>> {
  return request<MemberLinkInviteAcceptResponse>(
    "/api/me/link_invites/accept",
    { method: "POST", body: { code } },
  );
}

export type {
  MemberLinkInvite,
  MemberLinkInviteAcceptResponse,
  MemberLinkInviteCreateIn,
  MemberLinkInviteListResponse,
  MemberLinkInviteWithCode,
  MemberLinkUnlinkResponse,
};
